import { render, staticRenderFns } from "./EditDocsTemplate.vue?vue&type=template&id=0d794417&scoped=true"
import script from "./EditDocsTemplate.vue?vue&type=script&lang=js"
export * from "./EditDocsTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditDocsTemplate.vue?vue&type=style&index=0&id=0d794417&prod&scoped=true&lang=css"
import style1 from "./EditDocsTemplate.vue?vue&type=style&index=1&id=0d794417&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d794417",
  null
  
)

export default component.exports